import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { ManagedSuppliersApi } from "apis/ManagedSuppliersApi";
import { ManagedSupplier } from "models/dbModels/managedSuppliers/ManagedSupplier";
import { ManagedSuppliersSearchFilterQuery } from "models/filters/managedSuppliers/ManagedSuppliersSearchFilterQuery";

export const getSuppliers = createAsyncThunk("suppliersSlice/getSuppliers", async (keyword?: string) => {
    const response = await ManagedSuppliersApi.Search({ keyword: keyword });
    return response.data;
});

export const getSupplierDetails = createAsyncThunk("suppliersSlice/getSupplierDetails", async (supplierId: number) => {
    const response = await ManagedSuppliersApi.Search({ ids: [supplierId] });
    return response.data;
});

export const createSupplier = createAsyncThunk("suppliersSlice/createSupplier", async (supplier: ManagedSupplier) => {
    supplier = { ...supplier, id: 0, isSystem: false };
    const response = await ManagedSuppliersApi.Add([supplier]);
    return response.data;
});

export const updateSupplier = createAsyncThunk("suppliersSlice/updateSupplier", async (supplier: ManagedSupplier) => {
    const response = await ManagedSuppliersApi.Update([supplier]);
    return response.data;
});

export const deleteSupplier = createAsyncThunk("suppliersSlice/deleteSupplier", async (params: ManagedSuppliersSearchFilterQuery) => {
    const response = await ManagedSuppliersApi.Delete(params);
    return response.data;
});

type InitialStateType = {
    id: number;
    name: string;
    contactName: string | null;
    address: string | null;
    suburb: string | null;
    state: string | null;
    postcode: number | null;
    phoneNumber: string | null;
    faxNumber: string | null;
    systemCode: string | null;
    lock: boolean;
    active: boolean;
    modelId: string;
    loading: boolean;
    isSystem: boolean;
    selectedSupplierRows: any[];
    deselectedSupplierRows: any[];
    pageIndex: number;
    totalRows: number;
    totalRetreived: boolean;
    error: string;
    table: ManagedSupplier[];
};

const initialState: InitialStateType = {
    id: 0,
    name: "",
    contactName: "",
    address: null,
    suburb: null,
    state: null,
    postcode: null,
    phoneNumber: null,
    faxNumber: null,
    systemCode: null,
    lock: false,
    active: false,
    modelId: "",
    loading: false,
    isSystem: false,
    selectedSupplierRows: [],
    deselectedSupplierRows: [],
    pageIndex: 0,
    totalRows: 0,
    totalRetreived: false,
    error: "",
    table: [],
};

const suppliersSlice = createSlice({
    name: "suppliersSlice",
    initialState: {
        ...initialState,
    },
    reducers: {
        updateSupplierField: (state, action) => {
            return {
                ...state,
                [action.payload.key]: action.payload.value,
            };
        },
        cleanSupplierDetails: (state) => {
            return {
                ...state,
                ...initialState,
            }
        },
        addSelectedRows: (state, action) => {
            // @ts-ignore
            state.selectedSupplierRows[action.payload.index] = action.payload.rows;
        },
        addDeselectedRows: (state, action) => {
            // @ts-ignore
            state.deselectedSupplierRows[action.payload.index] = action.payload.rows;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getSuppliers.pending, (state, action) => {
            state.loading = true;
            state.table = [];
            state.error = "";
        });
        builder.addCase(getSuppliers.fulfilled, (state, action) => {
            state.table = action.payload.data ? action.payload.data : [];

            if (!state.totalRetreived) //Only get total on the first load - so we always know max amount
            {
                state.totalRows = action.payload.data.length;
                state.totalRetreived = true;
            }

            state.loading = false;
        });
        builder.addCase(getSuppliers.rejected, (state, action) => {
            state.table = [];
            state.loading = false;
            state.error = action.error.message || "";
        });
        builder.addCase(createSupplier.pending, (state, action) => {
            // return {
            //     ...state,
            //     ...initialState,
            // }
        });
        builder.addCase(getSupplierDetails.fulfilled, (state, action) => {
            return {
                ...state,
                ...action.payload.data[0],
            }
        });
    }
});

export const { cleanSupplierDetails, updateSupplierField, addSelectedRows, addDeselectedRows, } = suppliersSlice.actions;

export default suppliersSlice.reducer;